import theloop1 from "./1-13.png";
import theloop2 from "./2-15.png";
import theloop3 from "./3-13.png";
import theloop4 from "./4-15.png";

const Theloop = [theloop1, theloop2, theloop3, theloop4];

export default Theloop;
